// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3g2uA","card":"styles_card__1ThkK"};